import { Icon, IconsEnum } from 'components/Icons';
import { MovimentiDirezione, MovimentiStato, MovimentiTipologia } from 'types/swagger/movimenti';

import { MyAccountCms } from 'lib/datoCms/queries/getMyAccountPage';
import { SkeletonArea } from 'components/skeletonArea';
import { TransactionType } from 'types/dashboard/transactionType';
import { WidgetWithdrawItem } from './components/WidgetWithdrawItem';
import classNames from 'classnames';
import format from 'date-fns/format';
import styles from './WidgetWithdraw.module.scss';
import subDays from 'date-fns/subDays';
import { useGetLabelByKey } from 'hooks/useLingUI';
import { useGetMovimentiQuery } from 'features/api/userSlice';
import useWindowSize from 'hooks/useWindowSize';

type WidgetWithdrawProps = {
  cmsData: MyAccountCms;
  className?: string;
};

export const WidgetWithdraw = ({ cmsData, className }: WidgetWithdrawProps) => {
  const { isMobile } = useWindowSize();

  const labelAggiorna = useGetLabelByKey('aggiorna');

  const {
    data: transactionApprovalList,
    isLoading,
    isFetching,
    refetch,
  } = useGetMovimentiQuery(
    {
      dataDa: format(subDays(new Date(), 29), 'yyyy-MM-dd').toString(),
      dataA: format(new Date(), 'yyyy-MM-dd').toString(),
      stato: MovimentiStato.Tutto,
      direzione: MovimentiDirezione.Uscite,
      tipologia: MovimentiTipologia.BonusRicaricaPrelievo,
    },
    {
      selectFromResult: (response) => {
        const pendingAndApprovedTransactions = (response.data?.items ?? []).filter((item) => {
          const stato = item.stato?.replaceAll(' ', '').toUpperCase();
          const tipologia = item.tipologia?.toUpperCase();
          const descrizione = item.descrizione?.toUpperCase();
          return (
            ((stato === MovimentiStato.InApprovazione.toUpperCase() ||
              stato === MovimentiStato.Approvato.toUpperCase()) &&
              tipologia === 'PRELIEVO') ||
            descrizione === TransactionType.Voucher
          );
        });

        const contabilizzatoWithdrawBonifico = (response.data?.items ?? [])
          .filter(
            (item) =>
              item.stato === MovimentiStato.Contabilizzato &&
              item.descrizione === TransactionType.WithdrawCard &&
              new Date(item.dataOrdinamento ?? '') >= subDays(new Date(), 1)
          )
          .slice(-5);

        return { ...response, data: [...pendingAndApprovedTransactions, ...contabilizzatoWithdrawBonifico] };
      },
    }
  );

  if (!isLoading && transactionApprovalList?.length === 0) return;

  return (
    <div className={classNames(styles.container, className ?? '')}>
      <div className={styles.headerContainer}>
        <span className={styles.title}>{cmsData.labelWidgetWithdrawTitle}</span>
        <button type="button" onClick={refetch} className={styles.button}>
          <span className={styles.iconContainer}>
            <Icon iconId={IconsEnum.RELOAD_SPIN} className={styles.icon} />
          </span>
          {!isMobile && <span className={styles.label}>{labelAggiorna!}</span>}
        </button>
      </div>
      {!isFetching ? (
        <div className={styles.childrenContainer}>
          {transactionApprovalList?.map((item, index) => (
            <WidgetWithdrawItem item={item} key={`${item.idBiglietto}_${index}`} cmsData={cmsData} />
          ))}
        </div>
      ) : (
        <SkeletonArea height="13" internalClassName="noMargin" />
      )}
    </div>
  );
};
